"use strict";
window._theme = window._theme || {};

_theme.Helpers = (function(){
    function stringToHTML(str){
        if(!str) return null;
    
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    }

    async function updateLineItem(line, quantity, config) {
        const minicartElem = document.querySelector('.js-minicart .product-cart [data-line-index="'+line+'"]');
        if(minicartElem) minicartElem.classList.add('is-loading');

        try {
            const resp = await fetch('/cart/change.js', {
                method: "post",
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body: JSON.stringify({
                  "line": line,
                  "quantity": quantity,
                  "sections": "minicart",
                  "sections_url": window.location.pathname
                })
            });
            const cart = await resp.json();
            if(cart.status === 422) throw Error(cart.message);

            cartAddedCallBack(cart);
            if(minicartElem) minicartElem.classList.remove('is-loading');
        } catch (error) {
            if(minicartElem) minicartElem.classList.remove('is-loading');
            showToastNotification(error.message);
            if(config) config.qtyInput.val(config.prevQty); // reset qty
        }
    }

    function cartAddedCallBack(result) {
        //console.log('result:', result);
        const minicart = result.sections.minicart;
        const reqBody = stringToHTML(minicart);
        const cartjson = JSON.parse(
            reqBody.querySelector('script[type="application/json"]').textContent
        );
        if(window.viewCartevent) window.viewCartevent(cartjson);

        const cartTotalPrice = (cartjson.total_price / 100);
        const cartBottomSource = reqBody.querySelector('.js-minicart .mini-cart-bottom');
        const cartBottomDest = document.querySelector('.js-minicart .mini-cart-bottom');
        const checkoutBtn = document.querySelector('.js-minicart .action-checkout [data-checkout-act]');
        const cartErrElem = document.querySelector('.js-minicart .errors.cart-value-error');

        cartBottomDest.innerHTML = cartBottomSource.innerHTML;
        document.querySelectorAll('.js-number-cart, .cart-counter').forEach(elem => {
            elem.textContent = cartjson.item_count;
        });

        if(cartTotalPrice >= _theme.MIN_ORDER_AMT) {
            if(cartErrElem) cartErrElem.style.display = "none";
            if(checkoutBtn) {
                checkoutBtn.setAttribute('href','/checkout');
                checkoutBtn.removeAttribute('disabled');
            }
        } else {
            if(cartErrElem) cartErrElem.style.display = "block";
            if(checkoutBtn) {
                checkoutBtn.setAttribute('href','#');
                checkoutBtn.setAttribute('disabled', '');
            }
        }
    }

    function showToastNotification(msg, autohide, delay = 3000) {
        const toastModal = document.querySelector('[data-toast-notify]');
        if(!toastModal) return;
        const toastModalText = document.querySelector('[data-toast-notify] [data-toastmsg]');
        toastModalText.textContent = msg;
        toastModal.classList.add("active");
        
        if(autohide) {
            setTimeout(() => {
                toastModal.classList.remove("active");
            }, delay);
        }
    }

    function getPDPMinQty(qty, vid) {
        let bundleQty = qty;
        const minQtyJson = JSON.parse(document.querySelector('script[data-min-qty-json]')?.textContent?.trim() || '{}');
        const isPDPPage = document.querySelector('body.product') ? true : false;
    
        if(!isPDPPage || !minQtyJson.enable || !_theme.product_json) return {calcQty: qty};

        const tags = _theme.product_json.tags.map(tag => tag.trim().toLowerCase());
        if(!tags.includes(minQtyJson.tag.trim().toLowerCase())) return {calcQty: qty};
    
        const currentQty = Number(qty);
        const currentVid = Number(vid);
        let newQty = currentQty, matchFound = false;
    
        const matchedVariant = _theme.product_json.variants.find(v => Number(v.id) === currentVid);
        const matchedVariantPrice = matchedVariant.price / 100;
        const currentTotalPrice = matchedVariantPrice * currentQty;
    
        if(currentQty > matchedVariant.inventory_quantity) {
          const errMsg = minQtyJson.pdpErrorMsg.replace('{qty}', matchedVariant.inventory_quantity);
          _theme.Helpers.showToastNotification(errMsg);

          return {
            matchedVariant: matchedVariant,
            calcQty: matchedVariant.inventory_quantity
          }
        }
    
        if(currentTotalPrice < minQtyJson.matchPrice) {      
          while(!matchFound) {
            newQty++;
            const totalPrice = matchedVariantPrice * newQty;
            if(totalPrice >= minQtyJson.matchPrice) matchFound = true;
          }
          bundleQty = newQty;
          newQty = newQty > matchedVariant.inventory_quantity ? matchedVariant.inventory_quantity : newQty;
        }

        return {
            matchedVariant: matchedVariant,
            calcQty: newQty,
            bundleQty: bundleQty
        }
    }

    return {
        stringToHTML: stringToHTML,
        updateLineItem: updateLineItem,
        cartAddedCallBack: cartAddedCallBack,
        showToastNotification: showToastNotification,
        getPDPMinQty: getPDPMinQty
    }
})();